import _ from 'lodash'
const sortBy = (data, column, direction = 'ASC', cb = v => v) => {
  data.sort((a, b) => {
    if (direction === 'DESC') {
      return cb(b[column]) - cb(a[column])
    }
    return cb(a[column]) - cb(b[column])
  })

  return data
}

const sortHealthData = (data, column, secondColumn) => {
  if (_.isEmpty(data) || _.isEmpty(data.entry) || !_.isArray(data.entry)) {
    return data
  }

  data.entry = _.orderBy(
    _.get(data, 'entry', []),
    item => {
      return (
        (secondColumn
          ? _.get(item, column) || _.get(item, secondColumn)
          : _.get(item, column)) || ''
      )
    },
    'desc'
  )

  return data
}

export const sortMedications = data => {
  return sortHealthData(data, 'resource.authoredOn')
}

export const sortImmunizations = data => {
  return sortHealthData(data, 'resource.occurrenceDateTime')
}

export const sortAllergies = data => {
  return sortHealthData(data, 'resource.recordedDate')
}

export const sortHealthConditions = data => {
  return sortHealthData(
    data,
    'resource.onsetPeriod.start',
    'resource.recordedDate'
  )
}

export const sortRadiology = data => {
  return sortHealthData(data, 'resource.content[0].attachment.creation')
}

export const getDocumentDateOfService = item => {
  const content = _.get(item, 'resource.content', [])
  const pdfAttachment = _.filter(
    content,
    file => _.get(file, 'attachment.contentType') === 'application/pdf'
  )

  return (
    _.get(pdfAttachment, '[0].attachment.creation') ||
    _.get(item, 'resource.date', '')
  )
}

export const sortDocuments = data => {
  if (_.isEmpty(data) || _.isEmpty(data.entry) || !_.isArray(data.entry)) {
    return data
  }

  return {
    ...data,
    entry: _.orderBy(_.get(data, 'entry', []), getDocumentDateOfService, 'desc')
  }
}

export const sortTestResults = data => {
  return sortHealthData(data, 'resource.effectiveDateTime')
}

export default sortBy
